module.exports = __webpack_public_path__ + "img/bilboard.60eee976.webp";